import { AppActionTypes } from '../actions/AppAction';
import { CharacterActionTypes } from '../actions/CharacterAction';
import WriteDataMode from '../actions/WriteDataMode';
import InitializeResult from '../models/InitializeResult';

const initState = {
    initializeCompleted: true,
    initializeResult: null,
    initializeError: null,
};

const AppReducer = (state = initState, action) => {
    switch (action.type) {
        case AppActionTypes.Initialize:
            return {
                ...state,
                initializeCompleted: false,
            };
        case AppActionTypes.InitializeDone:
            if (action.error) {
                return {
                    ...state,
                    initializeCompleted: true,
                    initializeError: action.error,
                };
            } else {
                return {
                    ...state,
                    initializeCompleted: true,
                    initializeResult: action.initializeResult,
                    initializeError: null,
                }
            }
        case CharacterActionTypes.WriteCharacterDone:
            if (action.error) {
                return state;
            } else {
                const oldInitializeResult = state.initializeResult;
                const newInitializeResult = InitializeResult.deserialize(InitializeResult.serialize(oldInitializeResult));

                if (action.mode === WriteDataMode.add) {
                    newInitializeResult.characterCount += 1;
                } else if (action.mode === WriteDataMode.delete) {
                    newInitializeResult.characterCount -= 1;
                }

                return {
                    ...state,
                    initializeResult: newInitializeResult,
                }
            }
        default:
            return state;
    }
};

export default AppReducer;
